<template>
  <div>
    <template v-if="!isUserLoggedIn">
      <el-button type="text" @click="signIn">Sign in/Register</el-button>
    </template>
    <template v-else>
      <i
        :class="elUserIconClass"
        style="font-size: 1.6em; color:#777; z-index: 11"
      ></i>
      <el-dropdown trigger="click" @command="handleUserDropDownCommand">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon--right clickable"></i>
        </span>
        <el-dropdown-menu slot="dropdown" style="width:200px">
          <div
            class="userDisplayNamePlaceholder"
            v-if="showUsernamePlaceholder"
          ></div>
          <div
            style="padding-top: 10px;padding-bottom: 10px;margin-left: 20px;margin-right: 20px; font-size:15px"
            v-else
          >
            <p>{{ displayName }}</p>
            <p style="margin-top:10px; color: grey">{{ email }}</p>
          </div>
          <el-dropdown-item command="signout">Sign out</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "UserDropDownIcon",
  props: {
    isUserLoggedIn: {
      type: Boolean
    },
    displayName: {
      type: String
    },
    email: {
      type: String
    }
  },
  computed: {
    showUsernamePlaceholder() {
      // if the user is logged in but we don't have a display name,
      // it's likely this API request is in progress
      // show a placeholder if that's the case
      return this.isUserLoggedIn && !this.displayName;
    },
    elUserIconClass() {
      return "el-icon-user";
    }
  },
  methods: {
    ...mapActions(["logout"]),
    handleUserDropDownCommand(command) {
      switch (command) {
        case "signout":
          this.signOut();
          break;
        default:
          break;
      }
    },
    signOut: async function() {
      try {
        await this.logout();
      } catch (e) {
        console.warn(`Eror trying to call logout()`);
        console.log(e);
      } finally {
        this.$router.push({ name: "storefront" });
      }
    },
    signIn() {
      // Navigate to the signin page, including the current
      // page as a redirect, so the user is taken
      // back to their current page after login.
      // (if we are on the signin page already, this is not necessary)
      if (this.$route.name !== "signin") {
        this.$router.push({
          name: "signin",
          query: { redirect: this.$route.fullPath }
        });
      }
    }
  }
};
</script>

<style scoped>
.userDisplayNamePlaceholder {
  height: 15px;
  width: 150px;
  background-color: rgb(166, 166, 166);
  opacity: 0.1;
  border-radius: 4px;
  margin-left: 15px;
}
</style>
